<nav class="navbar navbar-expand-lg navbar-dark" style="background-color: #325a75; color:white;">
  <div class="container d-md-flex justify-content-md-center align-items-md-center">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav" >
      <ul class="navbar-nav ms-auto" style="color:white;">
        <li class="nav-item">
          <a class="nav-link" routerLink="/home" [attr.aria-label]="'home.title' | translate"> Inicio</a>
        </li>
        <li class="nav-item">
          <a class="nav-link dropdown-toggle" id="nosotrosDropdown" role="button">
            Nosotros
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link dropdown-toggle" id="repositorioDropdown" role="button">
            Sobre el Repositorio
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="text-white">
  <ngb-carousel [interval]="3500" [pauseOnHover]="false" [wrap]="true">
      <ng-template ngbSlide>
        <a href="http://repo.observatorioagro.gob.bo/communities/3ca131be-6fd2-415b-b7a4-500cc21d74e3" class="slide">
          <img
            src="assets/images/grafico1.jpg"
            alt="Gráfico 1"
            class="slide-image"
          />  
          <a href="http://repo.observatorioagro.gob.bo/communities/3ca131be-6fd2-415b-b7a4-500cc21d74e3" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa del Complejo Camélidos en el Altiplano</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a href="http://repo.observatorioagro.gob.bo/communities/783ef47d-4232-4261-bf0c-edd7304fc869" class="slide">
          <img
            src="assets/images/grafico2.jpg"
            alt="Gráfico 2"
            class="slide-image"
          />  
          <a href="http://repo.observatorioagro.gob.bo/communities/783ef47d-4232-4261-bf0c-edd7304fc869" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Cacao</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a href="http://repo.observatorioagro.gob.bo/communities/d83c2f74-cbf8-4784-a053-c2dd4308ea33" class="slide">
          <img
            src="assets/images/grafico3.jpg"
            alt="Gráfico 3"
            class="slide-image"
          />  
          <a href="http://repo.observatorioagro.gob.bo/communities/d83c2f74-cbf8-4784-a053-c2dd4308ea33" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Frutos Amazónicos</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a href="http://repo.observatorioagro.gob.bo/communities/1467ac1a-28a1-45f6-a198-a358d0fd502b" class="slide">
          <img
            src="assets/images/grafico4.jpg"
            alt="Gráfico 4"
            class="slide-image"
          />  
          <a href="http://repo.observatorioagro.gob.bo/communities/1467ac1a-28a1-45f6-a198-a358d0fd502b" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Hortalizas</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/grafico5.jpg"
            alt="Gráfico 5"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Piña</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/grafico6.jpg"
            alt="Gráfico 6"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Tuberculos y Raices</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/grafico7.jpg"
            alt="Gráfico 7"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Banano</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/grafico8.jpg"
            alt="Gráfico 8"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Granos Andinos</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/algodonB.jpg"
            alt="Gráfico 9"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Algodon</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/grafico10.jpg"
            alt="Gráfico 10"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Oliferas</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/grafico11.jpg"
            alt="Gráfico 11"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Urbano y Periurbano</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/apicolaB.jpg"
            alt="Gráfico 12"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Apicultura</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/ganaderiaB.jpg"
            alt="Gráfico 13"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Ganaderia</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/pescaB.jpg"
            alt="Gráfico 14"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Pesca</a>
        </a>
      </ng-template>
      <ng-template ngbSlide>
        <a class="slide">
          <img
            src="assets/images/grafico15.jpg"
            alt="Gráfico 15"
            class="slide-image"
          />  
          <a href="" style="font-size:1.8rem; color: #fff; font-weight:900;" class="slide-title">Programa Nacional de Frutos del Valle</a>
        </a>
      </ng-template>
  </ngb-carousel>
</div>


